var _polygon, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#12DB55"
    },
    d: "M496,379.6c0,9.6-7.2,16.8-16.8,16.8H16.8c-9.6,0-16.8-7.2-16.8-16.8v-264 c0-9.6,7.2-16.8,16.8-16.8h462.4c9.6,0,16.8,7.2,16.8,16.8L496,379.6L496,379.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#12DB55"
    },
    d: "M496,379.6c0,9.6-7.2,16.8-16.8,16.8H16.8c-9.6,0-16.8-7.2-16.8-16.8v-264 c0-9.6,7.2-16.8,16.8-16.8h462.4c9.6,0,16.8,7.2,16.8,16.8L496,379.6L496,379.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AC945"
    },
    d: "M0,115.6c0-9.6,7.2-16.8,16.8-16.8h462.4c9.6,0,16.8,7.2,16.8,16.8v264.8c0,9.6-7.2,16.8-16.8,16.8"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 118.8,
    style: {
      fill: "#334449"
    },
    width: 496,
    height: 96.8
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "170.4,215.6 496,215.6 496,118.8 5.6,118.8 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0CC69A"
    },
    d: "M496,379.6c0,9.6-7.2,16.8-16.8,16.8H16.8c-9.6,0-16.8-7.2-16.8-16.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0BAF84"
    },
    d: "M479.2,396.4c9.6,0,16.8-7.2,16.8-16.8h-44.8L479.2,396.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4F9ED"
    },
    d: "M177.6,264.4c0,3.2-2.4,5.6-5.6,5.6H52.8c-3.2,0-5.6-2.4-5.6-5.6l0,0c0-3.2,2.4-5.6,5.6-5.6H172 C175.2,258.8,177.6,261.2,177.6,264.4L177.6,264.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4F9ED"
    },
    d: "M177.6,293.2c0,3.2-2.4,5.6-5.6,5.6H52.8c-3.2,0-5.6-2.4-5.6-5.6l0,0c0.8-3.2,3.2-5.6,5.6-5.6H172 C175.2,287.6,177.6,290,177.6,293.2L177.6,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4F9ED"
    },
    d: "M154.4,322c0,3.2-2.4,5.6-5.6,5.6h-96c-2.4,0-4.8-2.4-4.8-5.6l0,0c0-3.2,2.4-5.6,5.6-5.6h96 C152,317.2,154.4,319.6,154.4,322L154.4,322z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFBC00"
    },
    cx: 360,
    cy: 300.4,
    r: 60
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA00"
    },
    d: "M360,240.4c-30.4,0-55.2,22.4-60,51.2l96.8,56.8c14.4-11.2,23.2-28,23.2-48 C420.8,266.8,393.6,240.4,360,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B208"
    },
    d: "M360,240.4c33.6,0,60,27.2,60,60s-27.2,60-60,60"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F20A41"
    },
    cx: 408,
    cy: 300.4,
    r: 60
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F20A41"
    },
    cx: 408,
    cy: 300.4,
    r: 60
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E00040"
    },
    d: "M408,361.2c-33.6,0-60-27.2-60-60s27.2-60,60-60"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97803"
    },
    d: "M384,245.2c-21.6,9.6-36,30.4-36,55.2s15.2,46.4,36,55.2c21.6-9.6,36-30.4,36-55.2 S405.6,254,384,245.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F76806"
    },
    d: "M384,355.6c21.6-9.6,36-30.4,36-55.2s-15.2-46.4-36-55.2"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.0d536e58.svg";
export { ForwardRef as ReactComponent };